// extracted by mini-css-extract-plugin
module.exports = {"tasksList":"tasksList--PHdPK"};